import React, { useState } from "react";
import { Modal } from "antd";
import { Document, Page, pdfjs } from "react-pdf";
import "react-pdf/dist/Page/TextLayer.css";
import "react-pdf/dist/Page/AnnotationLayer.css";

// pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;
pdfjs.GlobalWorkerOptions.workerSrc = "/pdf.worker.min.mjs";

const FooterPDFViewerModal = ({ open, onClose, title, fileUrl, isMobile }) => {
  const [numPages, setNumPages] = useState(0);

  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      title={title}
      width={isMobile ? "90%" : "60%"}
      centered
      className={`footer-pdf-viewer-modal ${isMobile ? "footer-mobile-viewer" : "footer-desktop-viewer"}`}
    >
      {fileUrl && (
        <div
          style={{
            height: "70vh",
            overflowY: "auto",
            overflowX: "hidden",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Document
            file={fileUrl}
            onLoadSuccess={({ numPages }) => setNumPages(numPages)}
          >
            {Array.from({ length: numPages }, (_, index) => (
              <Page
                  pageNumber={index + 1}
                  renderTextLayer={false}
                  renderAnnotationLayer={false}
                />
            ))}
          </Document>
        </div>
      )}
    </Modal>
  );
};

export default FooterPDFViewerModal;
